import { CREDIT_USAGE_DEMO_MP4 } from '@aibees/shared/constants';
import { Box, Modal } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { CreditUsageVideoModalProps as Props } from './types';

export const CreditUsageVideoModal = memo(({ open, onClose }: Props) => {
  return (
    <Modal open={open} onClose={onClose} aria-label="Credit usage demo video">
      <Box sx={SX.root}>
        {open && (
          <Box component="video" controls autoPlay muted sx={SX.video}>
            <source src={CREDIT_USAGE_DEMO_MP4} type="video/mp4" />
            Your browser does not support the video tag.
          </Box>
        )}
      </Box>
    </Modal>
  );
});

CreditUsageVideoModal.displayName = 'CreditUsageVideoModal';
